import { render, staticRenderFns } from "./CloseErrors.vue?vue&type=template&id=0bcd345e&"
import script from "./CloseErrors.vue?vue&type=script&lang=js&"
export * from "./CloseErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports